var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61539 0.5C7.72001 0.5 7.80769 0.587681 7.80769 0.692308V7.61539C7.80769 7.72001 7.72001 7.80769 7.61539 7.80769H0.692308C0.587681 7.80769 0.5 7.72001 0.5 7.61539V0.692308C0.5 0.587681 0.587681 0.5 0.692308 0.5H7.61539Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3068 0.5C17.4114 0.5 17.4991 0.587681 17.4991 0.692308V7.61539C17.4991 7.72001 17.4114 7.80769 17.3068 7.80769H10.3837C10.2791 7.80769 10.1914 7.72001 10.1914 7.61539V0.692308C10.1914 0.587681 10.2791 0.5 10.3837 0.5H17.3068Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3068 17.4991H10.3837C10.2791 17.4991 10.1914 17.4114 10.1914 17.3068V10.3837C10.1914 10.2791 10.2791 10.1914 10.3837 10.1914H17.3068C17.4114 10.1914 17.4991 10.2791 17.4991 10.3837V17.3068C17.4991 17.4114 17.4114 17.4991 17.3068 17.4991Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.692308 10.1914H7.61539C7.72001 10.1914 7.80769 10.2791 7.80769 10.3837V17.3068C7.80769 17.4114 7.72001 17.4991 7.61539 17.4991H0.692308C0.587681 17.4991 0.5 17.4114 0.5 17.3068V10.3837C0.5 10.2791 0.587681 10.1914 0.692308 10.1914Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu1);
export default __webpack_public_path__ + "static/media/Menu1.f5514a77fc78f0d9db3a23908c2cca21.svg";
export { ForwardRef as ReactComponent };